import Transformer from "./../transformer";

export default class completeOCsTransformer extends Transformer {
  static fetch(oc) {
    return {
      id: oc.id,
      folio: oc.folio,
    };
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/completeOCs.js